module.exports = __webpack_public_path__ + "img/false@2x.faae3d07.png";